import { render, staticRenderFns } from "./SkillsEditor.vue?vue&type=template&id=95a37782&scoped=true"
import script from "./SkillsEditor.vue?vue&type=script&lang=js"
export * from "./SkillsEditor.vue?vue&type=script&lang=js"
import style0 from "./SkillsEditor.vue?vue&type=style&index=0&id=95a37782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a37782",
  null
  
)

export default component.exports